module.exports = __webpack_public_path__ + "static/media/SING-RMIT-SG.3f76a3b9.jpeg";